
import styles from "./PartSurveyItemAdminUsed.module.scss";
import { useState } from "react";

import checkicon from 'assets/icons/check.png'
import circleicon from 'assets/icons/circle.png'
import squareicon from 'assets/icons/square.png'
import checksquareicon from 'assets/icons/square_check.png'
import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";

import { updatePointsPart } from "service/SurveyService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartSurveyItemUse = ({ item, item_selected, item_selected_data, index, setRender }) => {


    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });

    const getSelectedData = (defendantId, key) => {
        if (!Array.isArray(item_selected_data)) {
            console.warn("item_selected_data не массив", item_selected_data);
            return '';
        }
    
        // Проходим по массиву item_selected_data и ищем нужный defendantId
        for (const survey of item_selected_data) {
            if (!Array.isArray(survey.userusetsurveypart_employee_tsurveys)) continue;
    
            for (const test of survey.userusetsurveypart_employee_tsurveys) {
                if (test.defendant === defendantId) {
                    console.log(`Нашел test:`, test);
                    return test[key] || '';
                }
            }
        }
    
        console.warn(`Не найден defendantId: ${defendantId}`);
        return '';
    };
    
    
    

    const DraftContent = ({ draftData }) => {
        // Преобразуем данные из текста в объект
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
        } catch (error) {
            console.error("Ошибка обработки данных Draft.js:", error);
            return <p>Invalid content format</p>;
        }

        // Создаём состояние редактора для отображения
        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };




    const [text, setText] = useState('');
    const [settextelem, setTextElem] = useState(null);


    const handleSubmit = () => {
        try {
            const formData = new FormData();

            // Общие данные

            formData.append('text', text)
            updatePointsPart(item_selected_data[0]?.id, formData);
            setTextElem("В ожидании обновления");
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });
            setRender(true);
        } catch (error) {
            console.error("Ошибка отправки данных:", error);
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }
    };
    return (


        <div className={styles.defendant_card_selection} >

            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.defendant_card_selection_body}>

                <h3 style={{ marginTop: "-16px" }}> <DraftContent draftData={item.body} /></h3>
                {((Number(item_selected) !== Number(item.id)) && item.type_defendant !== "infoText") &&

                    <div className={styles.defendant_card_selection_body_defendant}>
                       
                        Не отвечено пользователем или Новый вопрос анкетирования
                    </div>
                }
                {Number(item_selected) === Number(item.id) &&
                    <>




                        <h4 style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', width: "100%", flexDirection: "column" }}>  Ответ пользователя:</h4>
                        <div className={styles.defendant_card_selection_body_defendant}>
                            {item.defendant_part_survey.map((defendant) => (
                                <div key={defendant.id} style={{ width: '100%' }}>
                                    {!['freeTextDefendant', 'infoText', 'fileUpload'].includes(item.type_defendant) && (
                                        <div className={styles.defendant_card_header}>
                                            {item.type_defendant === 'sequenceOrdering' && (
                                                <>
                                                    <DraftContent draftData={defendant.title} />
                                                    <select className={styles.point_check_num_text} value={getSelectedData(defendant.id, 'sequences_selectedNumber') || 1}>
                                                        <option value={getSelectedData(defendant.id, 'sequences_selectedNumber') || 1}>
                                                            {getSelectedData(defendant.id, 'sequences_selectedNumber') || 1}
                                                        </option>
                                                    </select>
                                                </>
                                            )}
                                            {item.type_defendant === 'slider' && (
                                                <div className={styles.slider_container}>
                                                    <h4>{defendant.type_input_txt}</h4>
                                                    {[getSelectedData(defendant.id, 'rdefendant'), defendant.rdefendant].map((val, index) => (
                                                        <div key={index} className={styles.slider_min_max}>
                                                            <input type="range" min={Math.min(defendant.min_len, defendant.max_len)} max={Math.max(defendant.min_len, defendant.max_len)} value={val || 0} style={{ width: '100%' }} readOnly />
                                                            <span className={styles.slider_min_max_res}>{val || ''}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                         {['numericInput', 'textInput'].includes(item.type_defendant) && (
  <input
    type={item.type_defendant === 'numericInput' ? 'number' : 'text'}
    value={getSelectedData(defendant.id, item.type_defendant === 'numericInput' ? 'type_input_int' : 'type_input_txt')}
    style={{
      border: '1px solid #292121',
      padding: '5px 10px',
      borderRadius: '6px',
      background: item.type_defendant === 'textInput' ? 'transparent' : 'transparent',
    }}
    placeholder={`Введите ${item.type_defendant === 'numericInput' ? 'цифры' : 'текст'}`}
    readOnly
  />
)}

                                            {['singleSelection', 'multipleSelection'].includes(item.type_defendant) && (
                                                <>
                                                    <input type={item.type_defendant === 'singleSelection' ? 'radio' : 'checkbox'} id={`defendant-${defendant.id}`} checked={!!getSelectedData(defendant.id, 'right_defendant')} readOnly />
                                                    <DraftContent draftData={defendant.title} />
                                                </>
                                            )}
                                        </div>
                                    )}
                                    {item.type_defendant === 'freeTextDefendant' && (
                                        <div className={styles.defendant_card_header}>
                                            <div className={styles.defendant_card_second_div}>{getSelectedData(defendant.id, 'free_response') || 'текст не найден'}</div>
                                        </div>
                                    )}
                                    {item.type_defendant === 'fileUpload' && (
                                        <div className={styles.defendant_card_header}>
                                            <div className={styles.defendant_card_second_div}>
                                                {getSelectedData(defendant.id, 'file') ? (
                                                    <>
                                                        <strong>Наименование файла:</strong> {getSelectedData(defendant.id, 'file').split('/').pop() || 'Имя файла не найдено'}
                                                        <br />
                                                        <button
                                                            className={styles.button_style}
                                                            onClick={() => {
                                                                const fileUrl = getSelectedData(defendant.id, 'file');
                                                                if (fileUrl) {
                                                                    const link = document.createElement('a');
                                                                    link.href = fileUrl;
                                                                    link.download = 'downloaded_file';
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                } else {
                                                                    alert('Файл для скачивания не найден');
                                                                }
                                                            }}
                                                        >
                                                            Скачать файл
                                                        </button>
                                                    </>
                                                ) : (
                                                    <div>Данные не найдены</div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {defendant.file && <img src={defendant.file} className={styles.img_file} alt="Uploaded file" />}
                                </div>
                            ))}
                            {item.comment && (
                                <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                                    <DraftContent draftData={item.comment} />
                                </div>
                            )}
                        </div>
                    </>
                }
            </div>

            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >





    );
};

export default PartSurveyItemUse;
